export default {
    indexConsistencies:             { method: 'get',    url: 'consistency_processes'},
    storeConsistency:               { method: 'post',   url: 'consistency_processes'},
    updateConsistency:              { method: 'put',    url: 'consistency_processes/{id}'},
    destroyConsistency:             { method: 'delete', url: 'consistency_processes/{id}'},
    indexConsistencyTypes:          { method: 'get',    url: 'consistency_processes/types'},
}